export default "__VITE_ASSET__CQIW3LRo__"